<template>
  <div>
    <b-modal
      id="edit-region-modal"
      ref="edit-region-modal"
      size="md"
      @hidden="cancel"
      :title="$t('modals.updateRegion.text')"
    >
      <!-- Name -->
      <div class="row">
        <div class="col-12 col-lg-12">
          <label for="name">{{$t("modals.name.text")}}</label>
          <b-form-input
            id="name"
            v-model="regionEdit.name"
            class="mb-1"
            :placeholder="$t('modals.name.text')"
            :state="err.name ? false : null"
          ></b-form-input>
          <b-form-invalid-feedback>
            {{ err.name }}
          </b-form-invalid-feedback>
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="row p-2">
          <div class="col-10 text-right p-1">
            <b-button variant="success" class="text-white" @click="edit(ok)">
              {{$t("buttons.update.text")}}
            </b-button>
          </div>
          <div class="col-2 text-center p-1">
            <b-button @click="cancel()"> {{$t("buttons.cancel.text")}} </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["region"],
  created() {},
  data() {
    return {
      regionEdit: {
        regionId: null,
        name: null,
      },
      err: {
        name: null,
      },
    };
  },
  watch: {
    region(newVal) {
      this.regionEdit = {
        regionId: newVal.id,
        name: newVal.name,
      };
    },
  },
  methods: {
    cancel() {
      this.clear();
    },
    clear() {
      /* this.regionEdit = {
        regionId: null,
        name: null,
      }; */
      this.err = {
        name: null,
      };
    },
    edit(ok) {
      if (!this.regionEdit.name) this.err.name = this.$t("msgError.obligField.text");
      else this.err.name = "";

      if (!this.err.name) {
        if (this.regionEdit.name != this.region.name) {
          ok();
          this.$emit("editRegion", this.regionEdit);
        } else {
          ok();
        }
      }
    },
  },
};
</script>